import axios from "axios";
import { useEffect } from "react";
import { uzCyrl } from "date-fns/locale";
import { linearGradient } from "framer-motion/client";
import { UNSAFE_DataRouterContext } from "react-router-dom";

// TODO: error handling with toastify or custom module
export async function getData(url) {
  console.log("getData");
  try {
    const response = await axios.get(url);
    console.log(response);
    const formatted = response.data.results.books;
    return formatted;
  } catch (error) {
    alert(error);
  }
}

export async function getCurrentData(url) {
  console.log("getData");
  try {
    const response = await axios.get(url);

    const formatted = response.data.results.lists;
    console.log(formatted);
    return formatted;
  } catch (error) {
    alert(error);
  }
}

export async function getText(url) {
  console.log("getText");
  try {
    const response = await axios.get(url);
    console.log(response);
    return response;
  } catch (error) {
    alert(error);
  }
}

export async function getSummary(title, showData, setShowData) {
  const url = `https://www.googleapis.com/books/v1/volumes?q=${title}&key=${process.env.REACT_APP_GOOGLE_KEY}`;
  const response = await getText(url);
  const description = response.data.items[0].volumeInfo.description;
  //setShowData({ ...showData, description: description });
  // move to each page after calling function
}

export async function getResults(response) {
  let bookObj;
  let bookObjs = [];
  const results = await Promise.all(
    response.map(async (item) => {
      if (item.display_name) {
        const category = { heading: item.display_name, img: "" };
        bookObjs.push(category);
      }

      item.books.map(async (book) => {
        // const googleDescription = await getLibraryData(book.title);
        if (book.book_image !== undefined) {
          bookObj = {
            img: book.book_image,
            ISBN: book.isbns[0].isbn13,
            description: book.description,
            amazon: book.amazon_product_url,
          };
        }

        bookObjs.push(bookObj);
      });
    }),
  );
  return bookObjs;
}

export async function getDateResults(response) {
  let bookObj;
  let bookObjs = [];
  console.log(response);
  const results = await Promise.all(
    response.map(async (book) => {
      const googleDescription = await getLibraryData(book.title);
      if (book.book_image !== undefined) {
        bookObj = {
          img: book.book_image,
          ISBN: book.isbns[0].isbn13,
          description: googleDescription,
          amazon: book.amazon_product_url,
        };
      }
      bookObjs.push(bookObj);
    }),
  );
  return bookObjs;
}

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export async function getLibraryData(title) {
  // get title
  try {
    const url = `https://www.googleapis.com/books/v1/volumes?q=${title}&feilds=volumeInfo.description&key=${process.env.REACT_APP_GOOGLE_KEY}`;

    const response = await axios.get(url);
    const description = response.data.items[0].volumeInfo.description;
    delay(1000);
    console.log("Delay");
    return description;
  } catch (err) {
    console.log(err);
    return;
  }
}

// get librivox link
export async function getLibrivoxLink(title) {
  let librivoxUrl;
  const response = await axios.get(
    `https://openlibrary.org/search.json?title=${title}`,
  );
  response.data.docs.map((item) => {
    if (item.id_librivox) {
      librivoxUrl = `https://librivox.org/${item.id_librivox[0]}`;
    }
  });
  return librivoxUrl;
}

export async function getTotal() {
  const response = await axios.get("/dataOpenLibrary.json");
  const numFound = response.data.numFound;
  return numFound;
}

export async function getGoogleData(bookObjs) {
  // get google isbn of embeddable books and descriptions and add to existing book objects
  const allBooks = [];
  const books = await Promise.all(
    bookObjs.map(async (book) => {
      try {
        const url = `https://www.googleapis.com/books/v1/volumes?&q=${book.title}&maxResults=1&fields=items&key=${process.env.REACT_APP_GOOGLE_KEY}`;
        const response = await axios.get(url);

        const embed = response.data.items[0].accessInfo.embeddable;

        if (embed) {
          response.data.items.map((item) => {
            let isbns = "";
            book.embed = embed;
            book.title = item.volumeInfo.title || "";

            if (item.volumeInfo) {
              book.ISBN = item.volumeInfo.industryIdentifiers[0].identifier;
            }
            if (item.volumeInfo.description) {
              book.description = item.volumeInfo.description;
            }

            allBooks.push(book);
          });
        }
        else {
          return
        }
      } catch (error) {
        console.log(error);

        // return;
      }
    }),
  );
  return allBooks;
}


export async function getClassics(pageNumber) {
  const urls = [];
  const bookObjs = [];

  try {
    console.log("Get Classics");
    // const response = await axios.get("/dataOpenLibrary.json");

    // TODO: send paginated data here

    const response = await axios.get(
      `https://openlibrary.org/search.json?q=classics&fields=author_name,title,id_amazon,cover_edition_key&page=${pageNumber}&limit=5`,
    );

    const hasImages = response.data.docs.filter(
      (item) => item.cover_edition_key != undefined,
    );

    const results = hasImages.map(async (item) => {
      const imageLink = `https://covers.openlibrary.org/b/olid/${item.cover_edition_key}-L.jpg`;

      const bookObj = {
        img: imageLink,
        amazon: item.id_amazon ? item.id_amazon[0] : "",
        title: item.title,
        librivox: "",
      };

      return bookObj;
    });

    const updatedResults = await Promise.all(
      results.map(async (item) => {
        const link = await getLibrivoxLink(item.title);
        item.librivox = link;
        return item;
      }),
    );
    return updatedResults;
  } catch (err) {
    alert("There was an error retreiving");
    console.log(err);
  }
}

export async function getLocalData() {
  let increment = 50;
  // for(let i = 50; i < 1000; i+=50){

  // }
  const data = await axios.get("./dataOpenLibrary.json");
  console.log(data.data.docs);
  const dataLength = data.data.docs.length;
}
